<template>
  <v-card outlined>
    <v-card-text>
      <div
        v-for="(event, index) in events"
        :key="index"
        class="my-2"
      >
        <v-btn
          :color="event.color"
          x-small
          fab
          class="mr-2 d-print-none"
        >
          <v-icon
            color="white"
            small
          >
            {{ event.icon }}
          </v-icon>
        </v-btn>
        <span>{{ event.text }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import _ from 'underscore'
import OrderHelper from './../Helpers/Order'

export default {
  props: {
    order: {
      type: Object,
      required: true
    }
  },

  computed: {
    events () {
      const events = []

      // order delivery slot moved
      if (this.order.timestamps.delivery_moved_at) {
        events.push({
          timestamps: this.order.timestamps.delivery_moved_at,
          icon: 'mdi-car',
          color: 'error',
          text: this.getOrderDeliverMovedAtInfo(this.order)
        })
      }

      // order edited
      if (this.order.timestamps.last_edited_at) {
        events.push({
          timestamps: this.order.timestamps.last_edited_at,
          icon: 'mdi-exclamation-thick',
          color: 'error',
          text: this.getOrderLastEditedAtInfo(this.order)
        })
      }

      return _.sortBy( events, 'timestamp')
    }
  },

  methods: {
    getOrderDeliverMovedAtInfo: OrderHelper.getOrderDeliverMovedAtInfo,
    getOrderLastEditedAtInfo: OrderHelper.getOrderLastEditedAtInfo
  }
}
</script>
